module.exports = __webpack_public_path__ + "media/images/product_large_images/printer1-387239653e038b1a3fa9c3cd2510730f.png";